import { render } from "./ButtonCheckboxComponent.vue?vue&type=template&id=0805d500"
import script from "./ButtonCheckboxComponent.vue?vue&type=script&lang=js"
export * from "./ButtonCheckboxComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__